import { ReportDetailPage } from '@/components/reports/ReportDetailPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/reports/$reportId')({
  component: RouteComponent,
});

function RouteComponent() {
  const reportId = Route.useParams().reportId;
  return <ReportDetailPage reportId={reportId} onBack={() => {}} />;
}
